import { LucideIcon } from 'lucide-react'
import { ActionButton } from './ActionButton'

export interface QuickAction {
  label: string
  onClick: () => void
  icon?: LucideIcon
  variant?: 'primary' | 'secondary' | 'ghost'
  loading?: boolean
  disabled?: boolean
}

export interface QuickActionsProps {
  actions: QuickAction[]
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function QuickActions({
  actions,
  size = 'md',
  className = '',
}: QuickActionsProps) {
  return (
    <div className={`quick-actions ${className}`}>
      {actions.map((action, index) => (
        <ActionButton
          key={index}
          variant={action.variant || 'primary'}
          size={size}
          icon={action.icon}
          onClick={action.onClick}
          loading={action.loading}
          disabled={action.disabled}
        >
          {action.label}
        </ActionButton>
      ))}
    </div>
  )
}
